<template>
  <div id="app">
    <div v-if="$store.state.sdkError" class="fixed top-0 left-0 w-full bg-red-100 text-red-700 text-center py-2 z-50">
      SDK 로드에 실패했습니다. 새로고침 후 다시 시도하세요.
    </div>
    <router-view></router-view>
    <portal-target name="modals" />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/* Webkit 기반 브라우저(크롬, 엣지, 사파리, iOS 사파리 등) */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent; /* 트랙(바탕)은 완전 투명 */
}
::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0); /* 기본 완전 투명 */
  border-radius: 8px;
  border: none;
  transition: background 0.2s;
}
::-webkit-scrollbar-thumb:hover,
::-webkit-scrollbar-thumb:active,
::-webkit-scrollbar-thumb:focus {
  background: rgba(255,255,255,0.7); /* 스크롤 이용 시 흰색(투명도 조절) */
}
::-webkit-scrollbar-track {
  background: transparent; /* 트랙(바탕)은 항상 완전 투명 */
}
/* 파이어폭스(윈도우, 맥, 리눅스) */
* {
  scrollbar-width: thin;
  scrollbar-color: transparent transparent; /* 기본 완전 투명 */
}
*:hover, *:active, *:focus {
  scrollbar-color: rgba(179, 177, 177, 0.521) transparent; /* 스크롤 이용 시 thumb만 흰색 */
}
.chat-message-content ul,
.chat-message-content ol {
  list-style-type: disc !important;
  margin-left: 1.5em !important;
  padding-left: 1.2em !important;
  list-style-position: outside !important;
  display: block !important;
}
.chat-message-content ol {
  list-style-type: decimal !important;
}
.chat-message-content li {
  margin-bottom: 0.3em !important;
  display: list-item !important;
}
</style> 